import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { ProtectedRouteProps } from '../../types/components';

/**
 * UserProtectedRoute component restricts access to routes that require authentication
 * 
 * Only users who have logged in (User or Admin) can access these routes.
 * Public users are redirected to the home page with a login prompt.
 * Special case: Purchase Result page is always accessible.
 * 
 * @param children - The components to render if access is allowed
 * @returns The protected route content or a redirect
 */
function UserProtectedRoute({ children }: ProtectedRouteProps) {
  const { isLoggedIn } = useUser();
  const location = useLocation();
  
  // Special case for purchase result page - always allow access
  const isPurchaseResult = location.pathname === '/purchase-result';
  
  if (!isLoggedIn && !isPurchaseResult) {
    // Redirect to home page with a login prompt
    return <Navigate to="/?login=required" replace />;
  }

  // User is logged in or this is the purchase result page, allow access
  return <>{children}</>;
}

export default UserProtectedRoute; 